import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const standingsMainContent = style({
  display: "grid",
  gap: vars.space.m,
});

export const standingsMainWrapper = style({
  display: "grid",
  gap: vars.space.m,
});
